import _ from 'lodash'
import { connect } from 'react-redux'
import { RootState } from 'duck/store'

import { getPastFundingRounds } from 'scenes/Dashboard/data/organizations/helpers'

import FundingRoundsTable, { FundingRoundsTableProps } from './presentational'

function mapStateToProps(state: RootState, { organization }: ContainerProps): StateProps {
  if (!organization) {
    return {}
  }

  const pastFundingRounds = getPastFundingRounds(organization)
  if (_.isEmpty(pastFundingRounds)) {
    return {}
  }
  return { fundingRounds: pastFundingRounds }
}

type StateProps = Pick<FundingRoundsTableProps, 'fundingRounds'>
type ContainerProps = Pick<FundingRoundsTableProps, 'organization'>

export default connect(mapStateToProps)(FundingRoundsTable)
